import React, { memo } from "react"

import styled from "styled-components"
import { useLocation } from "react-router-dom"

import { FlexItem, FlexRow, Flex } from "components/box"
import { PlainLink } from "components/text"
import Icon from "components/icon"

import RightNavigationPanelLoggedIn from "./components/right-panel-logged-in"
import RightNavigationPanel from "./components/right-panel"
import LeftNavigationPanel from "./components/left-panel"

import theme from "theme"

const HeaderLogo = styled(Icon)`
  svg {
    height: 1.25rem;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}px) {
    svg {
      height: 1.563rem;
    }
  }
`

type HeaderProps = {
  isLoggedIn?: boolean
  fullName?: string
}

const Header: React.FC<HeaderProps> = ({ isLoggedIn, fullName }) => {
  const location = useLocation()
  const hidePanel = location.pathname === "/purchase" || location.pathname.includes("purchase")

  return (
    <FlexRow justifyContent="center" position="relative" width="100%" zIndex={theme.layers.middle} px={[6, 6, 7, 7]}>
      <Flex width={1440} alignItems="center" justifyContent="center">
        {!hidePanel && (
          <FlexItem forwardedAs="nav" justifyContent="flex-start" flex={1}>
            <LeftNavigationPanel />
          </FlexItem>
        )}

        <PlainLink href="/">
          <HeaderLogo name="logo" py={[4, 4, 5, 5]} />
        </PlainLink>

        {!hidePanel && (
          <FlexItem justifyContent="flex-end" flex={1}>
            {isLoggedIn ? <RightNavigationPanelLoggedIn fullName={fullName!} /> : <RightNavigationPanel />}
          </FlexItem>
        )}
      </Flex>
    </FlexRow>
  )
}

export default memo(Header, (prevProps, nextProps) => prevProps.isLoggedIn === nextProps.isLoggedIn)
